import { useMemo } from 'react';

import _ from 'lodash';

import { useTranslation } from 'react-i18next';

import { ChevronDownIcon } from '@heroicons/react/16/solid';
import { LANGUAGES_FLAGS, LanguageFullNameEnum, LanguageEnum } from 'utils/constants';

import LanguageItem from './LanguageItem';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'components/ui/dropdown-menu.tsx';
import { Button } from 'components/ui/button.tsx';

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const flagImg = useMemo(() => {
    return LANGUAGES_FLAGS[i18n.language as LanguageEnum];
  }, [i18n.language]);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <Button variant='ghost'>
          <div className='flex items-center gap-[6px] cursor-pointer'>
            <img src={flagImg} className='w-[16px] h-[16px] rounded-[50%]' />
            <div className='text-grey500 text-base font-[MuseoSans900] uppercase tracking-[1.5px]'>{i18n.language}</div>
          </div>
          <ChevronDownIcon className='size-4 fill-grey500' />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className='w-40 bg-white border border-beige ring-0 ' align='start'>
        <DropdownMenuGroup>
          {_.map(_.keys(LanguageFullNameEnum), (lang: LanguageEnum) => (
            <DropdownMenuItem>
              <LanguageItem lang={lang} fullname={_.get(LanguageFullNameEnum, lang)} />
            </DropdownMenuItem>
          ))}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;
